import { NgModule} from '@angular/core';
import { FlexLayoutModule, MediaMarshaller } from '@angular/flex-layout';
import { ADPSharedModule } from 'digital-core';
import { GspMaterialModule } from './gsp-material.module';
import { GspPipesModule } from './gsp-pipes.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [],
  imports: [
    ADPSharedModule,
    GspMaterialModule,
    GspPipesModule,
    FlexLayoutModule,
    // GooglePlaceModule,
    ToastrModule.forRoot(),
  ],
  exports: [
    ADPSharedModule,
    GspMaterialModule,
    GspPipesModule,
    FlexLayoutModule,
    // GooglePlaceModule,
    ToastrModule
  ]
})
export class GspSharedModule { 
  lastValue;

  public constructor (
    m: MediaMarshaller,
  ) {
    // this is to resolve a known issue with flex-layout and print dialogs (verified to be an issue as late as 11.0.0-beta.33)
    // hack until resolve: https://github.com/angular/flex-layout/issues/1201
    // @ts-ignore
    m.subject.subscribe((x) => {
      // @ts-ignore
      if (m.activatedBreakpoints.filter((b) => b.alias === 'print').length === 0) {
        // @ts-ignore
        this.lastValue = [...m.activatedBreakpoints];
      } else {
        // @ts-ignore
        m.activatedBreakpoints = [...this.lastValue];
        // @ts-ignore
        m.hook.collectActivations = () => {};
        // @ts-ignore
        m.hook.deactivations = [...this.lastValue];
      }
    });
  }
}
